import authRules from '../authRules';

const deleteAssignment = (user) => {
  const { scheduleData } = user.securityLevels;
  if (scheduleData >= authRules.deleteAssignment.scheduleData) {
    return true;
  } else {
    return false;
  }
}

export default deleteAssignment;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/deleteAssignment.js